import {
    AUTOSHIP_UNIT_OF_MEASURE_BY_FREQUENCY_UNIT,
    type AutoshipFrequency,
    type AutoshipUnitOfMeasure,
    type CalculateFrequencyResponse,
} from '@libs/common-types';

export type MappedAutoshipFrequency = {
    autoshipFrequency: AutoshipFrequency;
    autoshipUnit: AutoshipUnitOfMeasure;
    recommendedAutoshipFrequency: CalculateFrequencyResponse['recommendedAutoshipFrequency'];
    recommendedAutoshipFrequencyUnit: CalculateFrequencyResponse['frequencyUnit'];
};

export const mapRecommendedFrequencyToAutoship = (
    recommendation: Pick<CalculateFrequencyResponse, 'recommendedAutoshipFrequency' | 'frequencyUnit'>
): MappedAutoshipFrequency => ({
    autoshipFrequency: String(recommendation.recommendedAutoshipFrequency) as AutoshipFrequency,
    autoshipUnit: AUTOSHIP_UNIT_OF_MEASURE_BY_FREQUENCY_UNIT[recommendation.frequencyUnit],
    recommendedAutoshipFrequency: recommendation.recommendedAutoshipFrequency,
    recommendedAutoshipFrequencyUnit: recommendation.frequencyUnit,
});

export const getSetFrequencyButtonLabel = ({
    recommendedAutoshipFrequency,
    recommendedAutoshipFrequencyUnit,
}: Pick<MappedAutoshipFrequency, 'recommendedAutoshipFrequency' | 'recommendedAutoshipFrequencyUnit'>): string =>
    `Set to every ${recommendedAutoshipFrequency} ${recommendedAutoshipFrequencyUnit}`;

export const getFrequencyUpdatedMessage = ({
    recommendedAutoshipFrequency,
    recommendedAutoshipFrequencyUnit,
}: Pick<MappedAutoshipFrequency, 'recommendedAutoshipFrequency' | 'recommendedAutoshipFrequencyUnit'>): string =>
    `Frequency updated to ${recommendedAutoshipFrequency} ${recommendedAutoshipFrequencyUnit}`;
